import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "./index.css";
import App from "./App.tsx";
import { middlewareService } from "./services/middleware/middlewareService";
import { installAxiosAuthInterceptor } from "./services/api/axiosAuthInterceptor";
import { installTranslatePatch } from "./utils/translatePatch";

// Make React resilient to DOM mutations from browser auto-translation
// (Chrome/Edge Translate, Google Translate extension). Must run before React mounts.
installTranslatePatch();

// Install the global 401 → re-authenticate interceptor before any API calls run.
installAxiosAuthInterceptor();

// Initialize Middleware before rendering the app
try {
  middlewareService.initialize();
} catch (error) {
  console.error("Failed to initialize Middleware:", error);
  // App continues to render even if Middleware fails
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
